import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { type Competition } from '@app/client/common/structs';
import { type FantasyLandingCollectionItemProps } from '@app/pages/FantasyLanding/Hero/HeroCollections/types';

type FantasyLandingAutoGeneratedLineupData = {
    activeGame?: Competition;
    activeRedirect: boolean;
    autoGeneratedLineup: Array<FantasyLandingCollectionItemProps>;
};
interface FantasyLandingAutoGeneratedLineupState extends FantasyLandingAutoGeneratedLineupData {
    setAutoGeneratedLineup: (lineup: Array<FantasyLandingCollectionItemProps>) => void;
    setActiveGame: (activeGame: Competition) => void;
    setActiveRedirect: (preventRedirect: boolean) => void;
    clearLineup: () => void;
}

const initialState: FantasyLandingAutoGeneratedLineupData = {
    activeRedirect: false,
    autoGeneratedLineup: [] as Array<FantasyLandingCollectionItemProps>,
    activeGame: undefined,
};

export const useFantasyLandingAutoGeneratedLineupStore = create<FantasyLandingAutoGeneratedLineupState>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                clearLineup: () => set(initialState),
                setAutoGeneratedLineup: (lineup) =>
                    set((state) => (state.activeRedirect ? state : { autoGeneratedLineup: lineup })),
                setActiveGame: (activeGame) => set((state) => (state.activeRedirect ? state : { activeGame })),
                setActiveRedirect: (activeRedirect) => set({ activeRedirect }),
            }),
            { name: 'fantasy-auto-generated-lineup-state-storage' },
        ),
    ),
);
